import React from 'react';
import { DialogBody, DialogTitle, Docked } from '@/ui/dialogs/Dialog';
import { FilterItem } from 'nike-ui/src/components/filters/types';
import RadioButton from '@/common/components/RadioButton';

export const TransferFilterDialog = ({
    title,
    options,
    value,
    onSubmit,
    dataAtid
}: {
    title: React.ReactNode;
    value?: FilterItem;
    options: FilterItem[];
    onSubmit: (selected: FilterItem) => void;
    dataAtid?: string;
}) => {
    return (
        <Docked>
            <DialogTitle>
                <h2>{title}</h2>
            </DialogTitle>
            <DialogBody>
                {options.map(option => (
                    <RadioButton
                        key={option.id}
                        active={value?.id === option.id}
                        onClick={() => onSubmit(option)}
                        value={option.id}
                        data-atid={dataAtid}
                    >
                        {option.value}
                    </RadioButton>
                ))}
            </DialogBody>
        </Docked>
    );
};
